
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"36","height":"36","stroke":"#6C7684","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M23.503 23.36a1.9 1.9 0 001.9-1.894v0c0-.533-.213-1.044-.59-1.42l-1.26-1.26v-3.745A5.547 5.547 0 0018 9.496v0a5.546 5.546 0 00-5.543 5.545v3.742l-1.26 1.26a2.007 2.007 0 00-.591 1.42v0a1.9 1.9 0 001.9 1.895l10.997.003z","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.52 26.502h2.959","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    